/**
 * Created by andrey on 27.02.2026
 */

const SyncTransportUtils = {
    addKeysPrefix: (prefix, data) => {
        const result = {};
        for (const key in data) {
            result[`${prefix}${key}`] = data[key];
        }
        return result;
    },

    removeKeysPrefix: (prefix, data) => {
        const result = {};
        for (const key in data) {
            if (key.startsWith(prefix)) {
                result[key.replace(prefix, "")] = data[key];
            }
        }
        return result;
    },

    serializeValues: (data) => {
        const result = {};
        for (const key in data) {
            result[key] = SyncTransportUtils.toString(data[key]);
        }
        return result;
    },

    deserializeValues: (data) => {
        const result = {};
        for (const key in data) {
            result[key] = SyncTransportUtils.parseValue(data[key]);
        }
        return result;
    },

    toString: (value) => (typeof value === "object" ? JSON.stringify(value) : `${value}`),

    parseValue: (value) => {
        try {
            const obj = JSON.parse(value);
            if (typeof obj === "object") {
                value = obj;
            }
        } catch (e) { /* empty */ }

        return value;
    }
};